/**
 * Created by Vladislav on 18.09.2024.
 */

cleverapps.InitConfigByType["merge2"] = function () {
    Families.initialize();
};

cleverapps.InitByType["merge2"] = function () {
    UnitsLibrary.Init();

    if (typeof StopGardenFeatures !== "undefined") {
        StopGardenFeatures();
    }

    if (typeof RepairLocation !== "undefined") {
        RepairLocation.GetMainScene = function () {
            return bundles.main.jsons.merge2scene_prefab_json;
        };
    }

    cleverapps.unitsShop = new Merge2UnitsShop();
    cleverapps.unitsShop.load();

    cleverapps.specialEnergyOffer = new SpecialEnergyOffer();

    cleverapps.energyBooster = new EnergyBooster();
  
    [Merge2CupTutorial, FlatMerge2BaseTutorial, Merge2StartFixTutorial,
        Merge2GeneratorTutorial, Merge2NewUnitTutorial, Merge2UnitsShopTutorial,
        Merge2BackpackTutorial, Merge2UndoTutorial, BoardFullTutorial,
        Merge2SpeedUpTutorial, MergeCustomGeneratorTutorial, RaveReviewsTutorial, RaveReviewsRewardTutorial,
        GeneratorMultiplierTutorial, SideQuestTutorial]
        .filter(Boolean).forEach((tutorial) => cleverapps.tutorial.register(tutorial()));
};

ControlButtons.list.splice(-2, 0, Merge2UnitShopControlButton);